import { render, staticRenderFns } from "./VersionAlert.vue?vue&type=template&id=0653c916"
import script from "./VersionAlert.vue?vue&type=script&lang=js"
export * from "./VersionAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0653c916')) {
      api.createRecord('0653c916', component.options)
    } else {
      api.reload('0653c916', component.options)
    }
    module.hot.accept("./VersionAlert.vue?vue&type=template&id=0653c916", function () {
      api.rerender('0653c916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/VersionAlert.vue"
export default component.exports